// BL-2553 — which phone screens are drill-downs. A drill-down starts with its own Back row, so the
// shell leaves the brand bar off it; a root screen keeps the bar and its hamburger.

import { isOfflineDocumentPath, onlinePathForOfflineDocument } from '../offline/offline-routes';

/** The auction-detail prefix: every `/auctions/<id>/…` segment mounts the auction's own header. */
const AUCTION_DETAIL_PREFIX = '/auctions/';

/** Whether a bare path is an auction-detail segment (`/auctions/<id>` or below). */
function isAuctionDetailPath(path: string): boolean {
    return path.startsWith(AUCTION_DETAIL_PREFIX) && path.length > AUCTION_DETAIL_PREFIX.length;
}

/**
 * Whether a location is a drill-down screen, which carries its own Back row in place of the
 * shell's brand bar.
 *
 * An offline document is classified as the online screen it stands in for, through the offline
 * route map's own reverse (`onlinePathForOfflineDocument`), so the two cannot drift.
 *
 * @param location - the pathname and query string, as `usePathname` and `useSearchParams` give them.
 * @returns true for `/auctions/a1`, `/auctions/a1/bidders` and `/offline/lots?auction=a1`; false for
 *   `/auctions`, `/offline/lots` with no auction, and every other root screen.
 */
export function isDrillDownRoute(location: { pathname: string; search: string }): boolean {
    const path = location.pathname.split(/[?#]/)[0].replace(/\/+$/, '');
    if (isOfflineDocumentPath(path)) {
        const online = onlinePathForOfflineDocument({ pathname: path, search: location.search });
        return isAuctionDetailPath(online.split(/[?#]/)[0]);
    }
    return isAuctionDetailPath(path);
}
